interface props {
 checked:boolean
 onChange:any
}

function TableCheckbox({checked,onChange}:props) {
  return (
    <div><input type='checkbox' checked={checked} onChange={onChange}/></div>
  )
}

export default TableCheckbox